<template>
<div class="chapter">
<div class="inner_page">
<p class="tx1">The German Occupation of the British Channel Islands during the Second World War is a matter of fact. Although mention is made of certain political and military leaders within the historical context of the period, it must be stressed that this is a work of fiction, nor is any reference intended to living persons.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm1.vue?f984f676